import { render, staticRenderFns } from "./CodesManager.vue?vue&type=template&id=c98d62c0&scoped=true"
import script from "./CodesManager.vue?vue&type=script&lang=js"
export * from "./CodesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98d62c0",
  null
  
)

export default component.exports